import { MarketConfig } from './market-config';
import { EU_PLATE_COUNTRY_CODES } from './plate-country-codes';

/** Ireland (vehlogs) – the first English market. */
export const MARKET_IE: MarketConfig = {
  id: 'ie',
  dataRegion: 'eu',
  currencyCode: 'EUR',
  preSelectedDistanceUnit: 'Kilometer',
  dateFormat: 'dd/MM/yyyy',
  firstDayOfWeek: 1,
  showHsnTsn: false,
  inspectionName: 'NCT',
  inspectionNameFull: 'NCT/CVRT',   // CVRT = the Irish test for commercial vehicles
  plate: {
    style: 'eu',
    preSelectedCountryCode: 'IRL',
    selectableCountryCodes: EU_PLATE_COUNTRY_CODES,   // Irish users may also own a car registered in another EU country
    hasRegionalCode: false,
    examplePlateText: '231-D-12345',
  },
};